function buildParams(method, body) {
  let header = {};
  if (body) {
    header = {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    };
    if (body instanceof FormData) {
      //
    } else {
      header['Content-Type'] = 'application/json';
    }
    return { method: method, headers: header, body: body };
  } else {
    header = { Authorization: `Bearer ${localStorage.getItem('token')}` };
    return { method: method, headers: header };
  }
}

const utils = {
  params: function (method, body) {
    let param = buildParams(method, body);
    return param;
  },

  buildTempShot: function (script, scene) {
    if (scene.shot_list) {
      return scene.shot_list;
    }
    // Manual scripts (no PDF) start with no shot at all — the user hasn't
    // generated anything yet. The only exception is when they're out of
    // credits and can't generate: then they fall back to the blank shot
    // like everyone else on the basic tier.
    const isManualScript = !script.script_path;
    if (isManualScript && !script.freemium_hard_paywall) {
      return null;
    }
    if (!script.features || script.features.toLowerCase() === 'basic') {
      return [
        {
          id: 0,
          scene_id: scene.id,
          shot_number: 1,
          original_shot_number: 1,
          shot_type1: null,
          selected_camera: null,
          VFX: 0,
          FX: 0,
          shot_description: '',
          notes: '',
          movement: [],
          camera: [],
          focus: [],
          frame: [],
          focal: [],
          subject: [],
          expanded: false,
        },
      ];
    }
    return null;
  },

  buildShotImageFilename: function (sceneNumber, shotNumber) {
    const scene = sceneNumber ?? 'x';
    const shot = shotNumber ?? 'x';
    return `scene-${scene}-shot-${shot}.png`;
  },

  // Returns `scenes` rearranged to follow `orderedIds`, with scene_position renumbered
  // to match. Scenes missing from `orderedIds` (e.g. one a collaborator just added) are
  // kept, after the ordered ones, rather than dropped.
  applySceneOrder: function (scenes, orderedIds) {
    const byId = new Map(scenes.map((scene) => [scene.id, scene]));
    const ordered = orderedIds.map((id) => byId.get(id)).filter(Boolean);
    const orderedSet = new Set(ordered);
    const rest = scenes.filter((scene) => !orderedSet.has(scene));
    return [...ordered, ...rest].map((scene, i) =>
      scene.scene_position === i + 1 ? scene : { ...scene, scene_position: i + 1 },
    );
  },

  downloadFile: function (url, filename) {
    if (!url) return;
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },

  isDarkColor: function (color) {
    if (!color) {
      return false;
    }

    let r, g, b;
    if (color.length === 7) {
      r = parseInt(color.slice(1, 3), 16);
      g = parseInt(color.slice(3, 5), 16);
      b = parseInt(color.slice(5, 7), 16);
    } else {
      return true;
    }

    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    return luminance < 128;
  },
};

export default utils;
